import { render, staticRenderFns } from "./MenuSubitem.vue?vue&type=template&id=2812552e&scoped=true"
import script from "./MenuSubitem.vue?vue&type=script&lang=js"
export * from "./MenuSubitem.vue?vue&type=script&lang=js"
import style0 from "./MenuSubitem.vue?vue&type=style&index=0&id=2812552e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812552e",
  null
  
)

export default component.exports